import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import moment from "moment";
import RegistrationPopup from "@/components/RegistrationPopup";
import { size, truncate, isEmpty } from "lodash";
import { useAuth } from "@/AuthProvider";
import roles from "@/constant/roles.config";
import { privateRoutePaths } from "@/routes/private.route.config";
import { buildPath } from "@/utils/common";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { Link } from "react-router-dom";

const InquiryCard = ({ data }) => {
  const { user, isPreKYCUser, isDemoUser, isEndUser, isViewer, isSuperAdmin } = useAuth();
  const navigate = useNavigate(null);
  const [smallmodalShow, setSmallModalShow] = useState(false);


  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  const handleRegistrationPopup = () => {
    let path = publicRoutePaths.REGISTRATION.path;
    if (isPreKYCUser) {
      path = `/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`;
    }
    if (isDemoUser) {
      path = `/${getPrefix()}${buildPath(privateRoutePaths.ADMIN_INQUIRIES, { fordate: "" })}`;
    }
    if (isEndUser) {
      path = `/${getPrefix()}${privateRoutePaths.MY_INQUIRIES.path}`;
    }
    if (isViewer) {
      path = `/${getPrefix()}${buildPath(privateRoutePaths.ADMIN_INQUIRIES, { fordate: "" })}`;
    }
    navigate(path);
  }

  useEffect(() => {
    const handleQuoteClick = (e) => {
      if (e.target.closest(`#registration_${data.id}`)) {
        setSmallModalShow(true);
      }
    };
    document.addEventListener("click", handleQuoteClick);
    return () => document.removeEventListener("click", handleQuoteClick);
  }, [data.id]);

  const redirectFun = (e, id) => {
    e.preventDefault();
    setSmallModalShow(false);

    if (!isEmpty(id)) {
      setTimeout(() => {
        navigate(`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: id })}`);
      }, 100);
    } else {
      setTimeout(() => {
        // navigate(publicRoutePaths.REGISTRATION.path);
        window.open(publicRoutePaths.REGISTRATION.path);
      }, 100);
    }
  };

  return (
    <div className="inquiry-card" key={`inq_card_${data.id}`}>
      <div className="head">
        <div className="title">
          <p className="">
            Inquiry Request
            <span className="">
              {moment(data.created_at).format("DD MMM YYYY")}
            </span>
          </p>
        </div>
        {(isPreKYCUser || user === null) && (
          <div
            id={data.id ? `registration_${data.id}` : "registration"}
            className="btn outline small inq-quote-btn"
          // onClick={handleQuoteClick}
          >
            Quote
          </div>
        )}
      </div>

      <div className="inquiry-details">
        <div className="location-text">
          <p className="">from <span className="">{data.country_from}</span></p>
        </div>
        <div className="detail-wrape">
          <div className="left-graphic">
            <span className="line"></span>
            <span className="icon">
              {data && data.freight_type === 'Air' && (
                <i className="sprite air" ></i>
                // <img src={Air} alt={data.freight_type} loading="lazy" />
              )}
              {data && data.freight_type === 'Ocean' && (
                <i className="sprite boat" ></i>
                // <img src={Boat} alt={data.freight_type} loading="lazy" />
              )}

            </span>
          </div>
          <div className="other-detail">
            <p className="label-texts">
              Containers/Boxes/Pallat/Packages
            </p>
            <p className="">
              <span title={size(data.cbpp) > 47 ? data.cbpp : ""}> {truncate(data.cbpp, {
                'length': 47,
                'omission': "..."
              })}</span>
            </p>
            <p className="">
              Commodity
              <span title={size(data.commodity) > 45 ? data.commodity : ""}>
                {truncate(data.commodity, {
                  'length': 45,
                  'omission': "..."
                })}
              </span>
            </p>
            <p className="">
              Term
              <span title={size(data.term) > 30 ? data.term : ""} > {truncate(data.term, {
                'length': 30,
                'omission': "..."
              })}</span>
            </p>
          </div>
        </div>
        <div className="location-text">
          <p className="">to <span className="">{data.country_to}</span></p>
        </div>
      </div>


      {smallmodalShow && (
        <RegistrationPopup
          title=""
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          onSubmit={handleRegistrationPopup}
          okButtonLabel={isDemoUser ? 'GO TO INQUIRIES' : isPreKYCUser ? 'GO TO PROFILE' : isViewer ? 'GO TO INQUIRIES' : isEndUser ? 'GO TO INQUIRIES' : 'REGISTER NOW'
          }
        >
          <div className="inner-wrape">
            {(() => {
              if (user && isPreKYCUser) {
                return (
                  <>
                    <div className="new-pop">
                      <div className="img-wrape"></div>
                      <div className="detail-wrape">
                        <div className="inner">
                          <h5 className="registor-now">Grow With Us!</h5>
                          <h6>Upgrade now to get more benefits!</h6>
                          <p className="registor-now-text">
                            Access special features, get personalized recommendations and connect with a growing community.
                          </p>
                          <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`} className="btn secondry-btn" onClick={(e) => {
                            redirectFun(e, user.member_id)
                          }}>
                            Go to Profile
                          </Link>
                        </div>
                      </div>
                    </div>
                  </>
                );
              } else {
                return (
                  <>
                    <div className="new-pop">
                      <div className="img-wrape"></div>
                      <div className="detail-wrape">
                        <div className="inner">
                          <h5 className="registor-now">Grow With Us!</h5>
                          <h6>Register now to get more benefits!</h6>
                          <p className="registor-now-text">
                            Access special features, get personalized recommendations and connect with a growing community.
                          </p>
                          <Link
                            to={publicRoutePaths.REGISTRATION.path}
                            className="btn secondry-btn"
                            onClick={(e) => {
                              redirectFun(e, null)
                            }}
                          >
                            Register Now
                          </Link>
                        </div>
                      </div>
                    </div>
                  </>
                );
              }
            })()}
          </div>
        </RegistrationPopup>
      )}
    </div>
  );
};

export default InquiryCard;